import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-generatedMappingFile',
    template: `
    <a (click)="downloadGlobalObject($event)" style="color: cornflowerblue;text-decoration: underline;">{{downloadGlobalObjects}}</a>`,
    standalone: false
})
export class DownloadGlobalObjects implements ICellRendererAngularComp {

  params;
  label: string;
  migrationId
  downloadGlobalObjects
  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
    console.log(this.params);
    this.migrationId=this.params.data.migrationId;
    var s3Path = this.params.data.s3Path
    if (s3Path == null || s3Path == undefined || s3Path == ''){

    }else {
      this.downloadGlobalObjects = this.params.data.lastModifiedDateTime
    }

    console.log(this.migrationId);
  }

  refresh(params?: any): boolean {
    return true;
  }

  downloadGlobalObject($event) {
    console.log("hello")
    if (this.params.downloadGlobalObject instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      console.log(params)
      this.params.downloadGlobalObject(params);

    }
  }
}
